import { render, staticRenderFns } from "./TrainingFilesModal.vue?vue&type=template&id=7bb60655"
import script from "./TrainingFilesModal.vue?vue&type=script&lang=js"
export * from "./TrainingFilesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports